import { render, staticRenderFns } from "./physical_properties.vue?vue&type=template&id=684fd1ef&"
import script from "./physical_properties.vue?vue&type=script&lang=js&"
export * from "./physical_properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports